export default {
    shift_deliveries: [],
    shift_delivery: null,
    pagination: {
        total: 1,
        current_page: 1,
    },
}
